import React, { useMemo, useState } from 'react';
import { Row, Col, Card, Button, Table, Select, Space, Typography, DatePicker, Statistic, Tag } from 'antd';
import { DownloadOutlined, BarChartOutlined, FundOutlined, RiseOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { RangePicker } = DatePicker;

const WhiteLabelAnalytics = () => {
  const [client, setClient] = useState('all');

  // Mock rollup data across clients
  const kpis = [
    { title: 'Total Impressions', value: 3_450_000, icon: <BarChartOutlined style={{ color: '#1677ff' }} /> },
    { title: 'Avg. IPM', value: 245, icon: <FundOutlined style={{ color: '#52c41a' }} /> },
    { title: 'CTR', value: '1.8%', icon: <RiseOutlined style={{ color: '#faad14' }} /> },
  ];

  const data = useMemo(() => ([
    { key: '1', client: 'Acme Co', campaigns: 7, impressions: 1_250_000, clicks: 23_500, ipm: 260, spend: 15000 },
    { key: '2', client: 'Northwind', campaigns: 2, impressions: 180_000, clicks: 2_100, ipm: 210, spend: 5000 },
    { key: '3', client: 'Contoso', campaigns: 4, impressions: 920_000, clicks: 14_800, ipm: 235, spend: 22000 },
    { key: '4', client: 'AdventureWorks', campaigns: 1, impressions: 120_000, clicks: 1_050, ipm: 195, spend: 3000 },
  ]), []);

  const clients = ['all', 'Acme Co', 'Northwind', 'Contoso', 'AdventureWorks'];

  const filtered = useMemo(() => (
    data.filter(r => client === 'all' || r.client === client)
  ), [data, client]);

  const columns = [
    { title: 'Client', dataIndex: 'client', key: 'client', render: (t) => <Text strong>{t}</Text> },
    { title: 'Campaigns', dataIndex: 'campaigns', key: 'campaigns', width: 110 },
    { title: 'Impressions', dataIndex: 'impressions', key: 'impressions', width: 140, render: (v) => v.toLocaleString() },
    { title: 'Clicks', dataIndex: 'clicks', key: 'clicks', width: 120, render: (v) => v.toLocaleString() },
    { title: 'IPM', dataIndex: 'ipm', key: 'ipm', width: 100, render: (v) => <Tag color={v >= 240 ? 'green' : 'gold'}>{v}</Tag> },
    { title: 'Spend', dataIndex: 'spend', key: 'spend', width: 120, render: (v) => `$${v.toLocaleString()}` },
  ];

  return (
    <div style={{ padding: 16 }}>
      <Space direction="vertical" size={12} style={{ width: '100%' }}>
        <div>
          <Title level={3} style={{ marginBottom: 0 }}>WhiteLabel Analytics & Reporting</Title>
          <Text type="secondary">View analytics across all clients. Filter by client/date and export.</Text>
        </div>

        {/* KPIs */}
        <Row gutter={[16, 16]}>
          {kpis.map(k => (
            <Col xs={24} sm={12} md={8} key={k.title}>
              <Card>
                <Space>
                  <div style={{ fontSize: 22 }}>{k.icon}</div>
                  <div>
                    <Text type="secondary">{k.title}</Text>
                    <div style={{ marginTop: 4 }}>
                      <Statistic value={k.value} />
                    </div>
                  </div>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Toolbar */}
        <Card bodyStyle={{ padding: 12 }}>
          <Row gutter={[12, 12]} align="middle">
            <Col xs={24} md={8}>
              <Select value={client} onChange={setClient} style={{ width: '100%' }}>
                {clients.map(c => (
                  <Select.Option key={c} value={c}>{c === 'all' ? 'All Clients' : c}</Select.Option>
                ))}
              </Select>
            </Col>
            <Col xs={24} md={10}>
              <RangePicker style={{ width: '100%' }} allowEmpty={[true, true]} />
            </Col>
            <Col xs={24} md={{ span: 6 }} style={{ textAlign: 'right' }}>
              <Space wrap>
                <Button icon={<DownloadOutlined />}>Export CSV</Button>
                <Button type="primary" icon={<DownloadOutlined />}>Export XLSX</Button>
              </Space>
            </Col>
          </Row>
        </Card>

        {/* Table */}
        <Card title="Performance by Client" bodyStyle={{ padding: 0 }}>
          <Table
            rowKey="key"
            columns={columns}
            dataSource={filtered}
            pagination={{ pageSize: 8 }}
          />
        </Card>
      </Space>
    </div>
  );
};

export default WhiteLabelAnalytics;
